<div @fadeInOut *ngIf="isVisible" class="animation-container {{ statusClass }}" (click)="hide()" (keyup.enter)="hide()"
  (keyup.space)="hide()" tabindex="0" role="button" aria-label="Close notification">
  <div class="animation-icon">
    {{ icon }}
  </div>
  <p class="animation-message">{{ message }}</p>
  <div class="progress-bar"></div>
</div>